export enum TipoFiltro {
    PLACA = 'por_placa',
    ARRENDANTE = 'por_arrendante',
    ARRENDATARIO = 'por_arrendatario'
}
